<template>
  <div class="flex flex-col gap-4 px-2 md:pt-2">
    <div class="flex flex-col">
      <div class="label">{{ $t('search.filters.classType') }}</div>
      <div class="mt-1 flex flex-wrap gap-1">
        <Chip
          v-for="item in otherFilters"
          :key="`kft-search-language-${item.key}`"
          :label="item.label"
          :selected="typeOfClass === item.key"
          class="chip-filter"
          @click="clickOtherFilter(item.key)"
        >
          {{ item.label }}
        </Chip>
      </div>
    </div>

    <FilterItemPriceRange
      :price-min="props.priceMin"
      :price-max="props.priceMax"
      @updated="(e) => emit('updated', e)"
    />

    <div class="flex flex-col">
      <div class="label">
        {{ $t('search.selectFiltersComponent.showEventsInPreferredLanguage') }}
      </div>
      <div v-if="availableLanguages" class="gap-1 flex flex-wrap mt-1">
        <Chip
          v-for="(language, code) in availableLanguages"
          :key="`kft-search-language-${code}`"
          :label="language"
          :selected="languages.includes(code)"
          class="chip-filter"
          @click="$emit('updated', { languages: code })"
          >{{ language }}
        </Chip>
        <!-- @pressed="fnToggleFacet('languages', code)" -->
        <!-- :value="temporaryFilters.languages.indexOf(code) !== -1" -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FilterItemPriceRange from '~/components/filter/FilterItemPriceRange.vue'
import { fnGetAvailableLanguages } from '~/utils/localeHelpers'

const PRICE_MIN = 0
const PRICE_MAX = 1200

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    hasAvailableDates?: boolean
    languages?: string[]
    priceMin?: number
    priceMax?: number
    typeOfClass?: string
  }>(),
  {
    hasAvailableDates: false,
    languages: () => [],
    priceMin: PRICE_MIN,
    priceMax: PRICE_MAX,
    typeOfClass: undefined,
  }
)

const emit = defineEmits(['updated'])

const typeOfClass = ref(props.typeOfClass)
const otherFilters = computed(() => [
  {
    key: 'publicEvents',
    label: t('search.filters.publicTickets'),
  },
  {
    key: 'directEvents',
    label: t('search.filters.privateGroups'),
  },
  {
    key: 'online',
    label: t('search.filters.onlineEvents'),
  },
])

const clickOtherFilter = (key: string) => {
  typeOfClass.value = typeOfClass.value === key ? undefined : key
  emit('updated', { typeOfClass: typeOfClass.value })
}

const i18n = useI18n()
const availableLanguages = fnGetAvailableLanguages(i18n)
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
.label {
  @apply h-9 font-medium text-black flex items-center;
}

.chip-filter {
  @apply m-0;

  &:not(.chip--selected) {
    @apply hover:border-teal-900 hover:bg-white hover:text-gray-700;
  }
}
</style>
